import { CalendarDays, KanbanSquare, Settings, Truck, Users } from "lucide-react"
import type { AreaNavItem } from "@/components/AppHeader"

/** Links do cabeçalho na área Produção. */
export const PRODUCAO_NAV: AreaNavItem[] = [
  { to: "/producao", label: "Quadro", icon: KanbanSquare, end: true },
  { to: "/producao/semana", label: "Semana", icon: CalendarDays },
  { to: "/producao/equipas", label: "Equipas", icon: Users },
  { to: "/producao/carrinhas", label: "Carrinhas", icon: Truck },
  { to: "/producao/configuracoes", label: "Configurações", icon: Settings },
]
